var a={disabled:false};export{a as default};
//# sourceMappingURL=config.js.map
